import { call, put } from 'redux-saga/effects';
import moment from 'moment';
import { SagaIterator } from 'redux-saga';
import * as pageStateService from '../../page-state/page-state.saga-services';
import * as actions from './reports.actions';
import { IMeetingSimple } from '../../../resource/meeting-simple/meeting-simple.types';
import { IUser } from '../../../resource/user/user.types';
import * as api from '../../../api/request-config/reports.api';
import { apiRequest } from '../../../api/api.saga-services';
import { IMeetingReportData, IMeetingReportsSearchParams, IReportsSearchParams } from './reports.types';

export function* fetchMeetingReports(
  meetingId: IMeetingSimple['id'],
  queryParams?: IMeetingReportsSearchParams,
): SagaIterator {
  let memberId: string | null = null;
  if (queryParams) {
    if (queryParams.dateSince) {
      queryParams.dateSince = moment(queryParams.dateSince).format('YYYY-MM-DD');
    }

    if (queryParams.dateUntil) {
      queryParams.dateUntil = moment(queryParams.dateUntil).format('YYYY-MM-DD');
    }
    if (queryParams.memberId) {
      memberId = queryParams.memberId;
    }
  }

  yield call(pageStateService.initPage, 'meetingReports');
  const meetingReports: IMeetingReportData = yield call(apiRequest, api.fetchMeetingReportsApi(meetingId, queryParams));
  if (!meetingReports) {
    return;
  }

  if (memberId) {
    const report = { [meetingId]: { byMember: { [memberId]: meetingReports } } };
    yield put(actions.storeMeetingReport(report));
  } else {
    const report = {
      [meetingId]: {
        general: { ...meetingReports },
      },
    };

    yield put(actions.storeMeetingReport(report));
  }

  yield call(pageStateService.completedInit, 'meetingReports');
}

export function* fetchUserReports(userId: IUser['id'], queryParams?: IReportsSearchParams): SagaIterator {
  if (queryParams) {
    if (queryParams.dateSince) {
      queryParams.dateSince = moment(queryParams.dateSince).format('YYYY-MM-DD');
    }
    if (queryParams.dateUntil) {
      queryParams.dateUntil = moment(queryParams.dateUntil).format('YYYY-MM-DD');
    }
  }

  yield call(pageStateService.initPage, 'meetingReports');
  const userReports: IMeetingReportData = yield call(apiRequest, api.fetchUserReportsApi(userId, queryParams));
  if (!userReports) {
    return;
  }

  yield put(actions.storeUserReports({ [userId]: userReports }));

  yield call(pageStateService.completedInit, 'meetingReports');
}
